// Import version module FIRST - sets window.__FIINDER_WIDGET_VERSION__ as a side effect
import "./lib/version";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ShadowHost } from "./components/ui/shadow-root.tsx";
import App from "./App.tsx";
import SessionBasedApp from "./SessionBasedApp";
import css from "./index.css?inline";
import { setupDevConfig } from "./dev-config";

// Setup dev config from Vite env vars (only sets if not already defined)
setupDevConfig();

// DEV ONLY: Render fullscreen iframe when iframe-url param is present
if (import.meta.env.DEV) {
  const params = new URLSearchParams(window.location.search);
  const iframeUrl = params.get("iframe-url");
  if (iframeUrl) {
    const iframe = document.createElement("iframe");
    iframe.src = iframeUrl;
    iframe.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;border:none;z-index:0;";
    document.body.prepend(iframe);
  }
}

declare global {
  interface Window {
    FIINDER_WIDGET_VERSION?: string;
    FIINDER_ROOT_ID?: string;
  }
}

const widgetVersion =
  typeof window !== "undefined" && window.FIINDER_WIDGET_VERSION
    ? window.FIINDER_WIDGET_VERSION.trim().toLowerCase()
    : "v1";

const SelectedApp = widgetVersion === "v2" ? SessionBasedApp : App;

const resolveMountNode = () => {
  const preferredRootId =
    typeof window !== "undefined" && window.FIINDER_ROOT_ID
      ? window.FIINDER_ROOT_ID.trim()
      : "root";

  const existingRoot = document.getElementById(preferredRootId);
  if (existingRoot) return existingRoot;

  const fallbackRoot = document.createElement("div");
  fallbackRoot.id = preferredRootId || "root";
  document.body.appendChild(fallbackRoot);
  return fallbackRoot;
};

createRoot(resolveMountNode()).render(
  <StrictMode>
    <ShadowHost css={css}>
      <SelectedApp />
    </ShadowHost>
  </StrictMode>
);
